var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Header',[_c('UiTabs',[(_vm.hasBase)?_c('UiTab',{attrs:{"to":'/map/territory?location=' + _vm.base.territory}},[_vm._v("Main")]):_c('UiTab',{attrs:{"to":'/map/territory?location=' + _vm.rnd}},[_vm._v("Main")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }